import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import FieldTitle from 'components/aor/FieldTitle';
import SelectField from 'material-ui/SelectField';
import utils from 'helpers/utils';
import { isEmpty } from 'lodash';
import translate from 'components/hoc/translate';

class GenerateSelectField extends Component {
    state = {
        choices: [],
    };

    componentDidMount() {
        const {
            choices,
            optionText,
            optionValue,
            translate,
        } = this.props;

        const option = {
            [optionText]: `${ utils.uuid() } (${ translate('actions.generated') })`,
            [optionValue]: utils.uuid(),
        };

        this.setState({
            choices: [
                ...choices,
                option,
            ],
        });
    }

    componentDidUpdate(prevProps) {
        if (!isEmpty(utils.diffArrays(this.props.choices, prevProps.choices))) {
            this.setState(({ choices }) => {
                const generatedOption = choices.pop();

                return {
                    choices: [
                        ...this.props.choices,
                        generatedOption,
                    ],
                };
            });
        }
    }

    handleChange = (event, index, value) => {
        const { onChange } = this.props.input;

        onChange(value);
    }

    render() {
        const {
            className,
            disabled,
            menuStyle,
            floatingLabelFixed = false,
            fullWidth = false,
            label,
            resource,
            source,
            input: {
                onBlur,
                value,
            },
            meta: {
                error,
                touched,
            },
            optionText,
            optionValue,
        } = this.props;

        const {
            choices,
        } = this.state;

        return (
            <SelectField
                className={ className }
                disabled={ disabled }
                multiple={ false }
                menuStyle={ menuStyle }
                value={ value }
                onBlur={ onBlur }
                onChange={ this.handleChange }
                errorText={ touched && error }
                floatingLabelText={
                    label ? <FieldTitle label={ label } source={ source } resource={ resource } /> : false
                }
                fullWidth={ fullWidth }
                floatingLabelFixed={ floatingLabelFixed }
            >
                {
                    choices.map((choice) => {
                        return (
                            <MenuItem
                                key={ utils.uuid() }
                                value={ choice[optionValue] }
                                primaryText={ choice[optionText] }
                            />
                        );
                    })
                }
            </SelectField>
        );
    }
}

GenerateSelectField.defaultProps = {
    choices: [],
    optionText: 'name',
    optionValue: 'id',
};

GenerateSelectField.propTypes = {
    choices: PropTypes.array.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.value,
    }).isRequired,
    label: PropTypes.string,
    meta: PropTypes.object,
    menuStyle: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    onChange: PropTypes.func,
    optionText: PropTypes.string,
    optionValue: PropTypes.string,
    translate: PropTypes.func,
};

export default translate(GenerateSelectField);


// WEBPACK FOOTER //
// ./src/components/input/SelectField/GenerateSelectField.js